import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { EmptyStateModule } from '@shared/components/empty-state/empty-state.module';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';  // Required for paginator to work with tables
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { NgxTippyModule } from 'ngx-tippy-wrapper';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { AvatarModule } from '@shared/components/avatar/avatar.module';
import { CreateContactFromLeadComponent } from '@feature/lead-search/components/lead-search/dialogs/create-contact-from-lead-content.component';
import { FiltersModule } from '@shared/components/filters/filters.module';
import { LeadSearchComponent } from '@feature/lead-search/components/lead-search/lead-search.component';
import { MaterialModule } from '@shared/bundles/material/material.module';
import { ToolbarModule } from '@shared/components/layout/toolbar/toolbar.module';
import { SfxLayoutModule } from '@shared/bundles/material/layout.module';
import { getCustomPaginatorIntl } from '../../core/utils/custom-paginator-intl';

import { ChoosePipelineComponent } from './components/lead-search/dialogs/choose-pipeline-content.component';

@NgModule({
    declarations: [
        LeadSearchComponent,
        CreateContactFromLeadComponent,
        ChoosePipelineComponent
    ],
    exports: [],
    imports: [
        AvatarModule,
        CommonModule,
        ClipboardModule,
        EmptyStateModule,
        FiltersModule,
        FormsModule,
        MatTooltipModule,
        MaterialModule,
        UIRouterModule,
        ToolbarModule,
        MatPaginatorModule,
        MatTableModule,  // Required for working with paginator & data
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        NgxTippyModule,
        SfxLayoutModule,
        TranslateModule
    ],
    providers: [
        {
            provide: 'sfWalkthrough',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('sfWalkthrough');
            }
        },
        {
            provide: 'modelService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('model');
            }
        },
        { provide: MatPaginatorIntl, useFactory: getCustomPaginatorIntl, deps: [TranslateService] },
        {
            provide: 'stateService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('$state');
            }
        },
        {
            provide: 'emailService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('email');
            }
        },
        {
            provide: 'pipelinesService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('pipelines');
            }
        },
        {
            provide: 'workflowService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('workflowService');
            }
        },
        {
            provide: 'filterService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('filterService');
            }
        },
        {
            provide: 'flagsService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('flagsService');
            }
        },
        {
            provide: 'dialogService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('$mdDialog');
            }
        },
        {
            provide: 'leadsService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('leadsService');
            }
        },
        {
            provide: 'utilsService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('utils');
            }
        },
        {
            provide: 'contactService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('contact');
            }
        },
        {
            provide: 'windowService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('$window');
            }
        }
    ]
})
export class LeadSearchModule {}
